import { UserAccountInfo } from "./UserAccountInfo";
export var getUserAccountInfo = function getUserAccountInfo() {
  return UserAccountInfo.getInstance().getData();
};